import { Flex, Text, Skeleton, Box } from "@mantine/core";

export const TemplateCell: React.FC<any> = ({ data, renderParams }) => {
  const { fields, template } = renderParams;
  
  const fieldValues = Object.keys(fields).reduce((acc, key) => {
    const dataPath = fields[key];
    const value = dataPath
      .split(".")
      .reduce((obj:any, prop:any) => (obj ? obj[prop] : undefined), data);
    acc[key] = value;
    return acc;
  }, {} as { [key: string]: any });
  
  let renderedContent = template;
  Object.keys(fieldValues).forEach((key) => {
    const regex = new RegExp(`{${key}}`, "g");
    const value = fieldValues[key]?.toLocaleString();
    renderedContent = renderedContent.replace(
      regex,
      value !== undefined && value !== null ? value : ""
    );
  });
  
  return (
    <Flex justify="center" align="center">
      <Text>{renderedContent}</Text>
    </Flex>
  );
};

// Skeleton component for TemplateCell
export const TemplateCellSkeleton: React.FC<{ col: any }> = ({ col }) => {
  const columnWidth = col.width;
  const minWidth = col.minWidth;
  const maxWidth = col.maxWidth;
  
  // Template cells typically show centered text
  const width = columnWidth ? Math.min(parseInt(columnWidth) * 0.8, 100) : "80%";
  
  return (
    <Box 
      sx={{ 
        width: columnWidth || "100%", 
        minWidth, 
        maxWidth,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Skeleton height={16} width={width} radius="sm" />
    </Box>
  );
};